<template>
  <div>
    <v-card flat>
      <v-toolbar flat>
        <!-- Filter Dropdown -->
        <v-select
          v-model="selectedStatus"
          :items="statusOptions"
          label="Filter by Status"
          dense
          outlined
          hide-details
          class="mr-4"
          style="max-width: 150px"
          @change="get_Rfid_list"
        ></v-select>

        <v-spacer />
        <v-btn small color="primary" class="white--text" @click="claim_box()"><v-icon small>mdi-plus</v-icon>Add</v-btn>
      </v-toolbar>

      <v-card-text>
        <v-data-table
          :headers="tabledata"
          :items="rfidList"
          dense
          :height="height"
          class="overflow-y-auto overflow"
          :items-per-page="10"
          :fixed-header="fixed"
          :loading="isLoading"
          loading-text="Loading... Please wait"
          :footer-props="{
            'items-per-page-options': [10, 15, 20, 25],
          }"
          no-data-text="No RFID records found for the selected status."
        >
          <template v-slot:[`item.box_created_on`]="{ item }">
            {{ formatReadableDate(item.box_created_on) }}
          </template>
          <template v-slot:[`item.box_claimed_on`]="{ item }">
            {{ formatReadableDate(item.box_claimed_on) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <Overlay :overlay="overlay" />
    <SnackBar :SnackBarComponent="SnackBarComponent" />

    <div v-if="componentCheck == 1">
      <CreateRfidBox
        :createboxDialog="createboxDialog"
        @clicked="createboxDialog = false"
        :AllOrgObject="sorted_organisationItems"
        v-on:errorMsg="error_info"
        v-on:successMsg="success_info"
      />
    </div>
  </div>
</template>


<script>
import CreateRfidBox from "@/components/Dialogs/CreateRfidBox.vue";
import { API, graphqlOperation } from "aws-amplify";
import { ListAllOrganisationByStatus, list_rfid_box } from "@/graphql/queries.js";
import SnackBar from "@/components/SnackBar.vue";
import Overlay from "@/components/Overlay.vue";

export default {
  components: {
    CreateRfidBox,
    SnackBar,
    Overlay,
  },
  data: () => ({
    fixed: true,
    isLoading: false,
    height: 0,
    rfidList: [],
    selectedStatus: "ACTIVE", // 👈 default filter
    statusOptions: ["ACTIVE", "DEACTIVE"], // 👈 dropdown items
    tabledata: [
      { text: "Box Id", value: "box_id" },
      { text: "Created On", value: "box_created_on" },
      { text: "Organization Name", value: "organisation_name" },
      { text: "Claimed", value: "is_claimed" },
      { text: "Claimed On", value: "box_claimed_on" },
      { text: "Swipes", value: "total_count_of_swipes" },
    ],
    componentCheck: 0,
    SnackBarComponent: {},
    overlay: false,
    createboxDialog: false,
    sorted_organisationItems: [],
  }),

  created() {
    this.height = window.innerHeight - 205;
    this.get_organisation_list();
    this.get_Rfid_list();
  },

  methods: {
    claim_box() {
      this.componentCheck = 1;
      this.createboxDialog = true;
    },

    error_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
    },

    success_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
      this.createboxDialog = false;
      this.get_organisation_list();
      this.get_Rfid_list();
    },

    async get_organisation_list() {
      this.overlay = true;
      try {
        let result = await API.graphql(
          graphqlOperation(ListAllOrganisationByStatus, {
            input: {
              organisation_status: "ACTIVE",
              organisation_type: "CUSTOMER",
            },
          })
        );
        const parsedData = JSON.parse(result.data.ListAllOrganisationByStatus);
        this.sorted_organisationItems = parsedData.sort((a, b) =>
          a.organisation_name > b.organisation_name ? 1 : -1
        );
      } catch (err) {
        console.log("error", err);
      } finally {
        this.overlay = false;
      }
    },

    async get_Rfid_list() {
  this.isLoading = true;
  this.overlay = true;

  try {
    const result = await API.graphql(
      graphqlOperation(list_rfid_box, {
        input: {
          box_status: this.selectedStatus, // 👈 Active / Deactive filter
        },
      })
    );

    const response = JSON.parse(result.data.list_rfid_box);

    if (response.Status === "Success" && Array.isArray(response.data) && response.data.length > 0) {
      // ✅ If data exists
      this.rfidList = response.data;
    } else {
      // ⚠️ If failed OR no data
      this.rfidList = [];
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        Top: true,
        SnackbarText: response.Message || "No Record Found",
        timeout: 4000,
      };
    }
  } catch (err) {
    console.log("error", err);
    this.rfidList = [];
    this.SnackBarComponent = {
      SnackbarVmodel: true,
      SnackbarColor: "red",
      Top: true,
      SnackbarText: err.errors?.[0]?.message || "Error fetching RFID list",
      timeout: 4000,
    };
  } finally {
    this.isLoading = false;
    this.overlay = false;
  }
},

    formatReadableDate(timestamp) {
      if (!timestamp) return "";
      const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
      const date = new Date(Number(ts));
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
  },
};
</script>
